// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.ce-brand {
  background-color: var(--ce-grey-4);
  text-align: center;
  padding: var(--ce-base-padding-large);
  color: var(--ce-grey-55);
  display: flex;
  justify-content: center;
  align-items: center;
}

header.ce-brand .ce-brand-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  line-height: 1.3;
}

header.ce-brand a {
  color: var(--ce-white);
  text-decoration: none;
}

header.ce-brand .project-hosting {
  margin-right: 10px;
}

header.ce-brand .ce-brand-logo {
  vertical-align: middle;
  margin: 0 10px 0 0;
  max-width: 150px;
}

@media (max-width: 767px) {
  header.ce-brand {
    padding: 10px;
  }

  header.ce-brand .ce-brand-content {
    font-size: var(--ce-body-small);
    text-align: left;
    justify-content: center;
    flex-wrap: wrap;
    line-height: 1.3;
  }
}


@media (max-width: 575px) {
  header.ce-brand a {
    display:flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/LoginHeader.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF","sourcesContent":["header.ce-brand {\n  background-color: var(--ce-grey-4);\n  text-align: center;\n  padding: var(--ce-base-padding-large);\n  color: var(--ce-grey-55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nheader.ce-brand .ce-brand-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  line-height: 1.3;\n}\n\nheader.ce-brand a {\n  color: var(--ce-white);\n  text-decoration: none;\n}\n\nheader.ce-brand .project-hosting {\n  margin-right: 10px;\n}\n\nheader.ce-brand .ce-brand-logo {\n  vertical-align: middle;\n  margin: 0 10px 0 0;\n  max-width: 150px;\n}\n\n@media (max-width: 767px) {\n  header.ce-brand {\n    padding: 10px;\n  }\n\n  header.ce-brand .ce-brand-content {\n    font-size: var(--ce-body-small);\n    text-align: left;\n    justify-content: center;\n    flex-wrap: wrap;\n    line-height: 1.3;\n  }\n}\n\n\n@media (max-width: 575px) {\n  header.ce-brand a {\n    display:flex;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
